/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/promise-function-async */
import { Button, Divider, Stack, Typography } from '@mui/material';
import { useRef } from 'react';
import generatePDF from 'react-to-pdf';

import { ADDRESS, EMAIL, PHONE } from '@app/configs';
import { Logo, Scrollbar } from '@app/components';
import { CompensationSchema } from '../type';

interface Props {
  data?: CompensationSchema;
}

const Compensation = ({ data }: Props) => {
  const targetRef: any = useRef(null);
  const printPDF = () => generatePDF(targetRef, { filename: 'compensation-letter.pdf' });

  return (
    <>
      <Stack width="50vw" alignSelf="center" padding="35px">
        <Button variant="contained" onClick={printPDF}>
          Download PDF
        </Button>
      </Stack>
      <Scrollbar>
        <Stack ref={targetRef}>
          <Stack
            my={4}
            alignItems={'center'}
            sx={{
              backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(/assets/background/logoSG.png)`,
              backgroundSize: '400px',
              backgroundPosition: 'center bottom',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <Stack
              height={'1392px'}
              width={'795px'}
              px={'15px'}
              sx={{ boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.5)' }}
            >
              <Stack
                py={'15px'}
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Stack>
                  <Logo disabledLink sx={{ height: 120, width: 225 }} />
                </Stack>
                <Stack width={'170px'}>
                  <Typography
                    variant="caption"
                    sx={{ lineHeight: 1.2, fontFamily: 'Verdana, sans-serif' }}
                  >
                    {ADDRESS} <strong>Mob: </strong>
                    {PHONE} <strong>Email:</strong> {EMAIL}
                  </Typography>
                </Stack>
              </Stack>

              <Divider
                sx={{
                  borderColor: '#3AC1EF',
                  borderWidth: '2px',
                  boxShadow: '2px 4px 4px 0 rgba(0, 0, 0, 0.5)',
                }}
              />

              <Stack gap={1.5} paddingTop={'30px'}>
                <Typography>
                  Hi<b> Mr./Ms. {`${data ? data.name : 'Name'}`}, </b>
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  We appreciate your enhancing performance with us. The company is very happy to
                  inform you that your compensation has been revised.
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  The revised salary will be
                  <b> {`${data ? data.revisedSalary : 'Revised Salary'}`}/- </b>per month, effective
                  <b> {`${data ? data.date : 'Date'}.`} </b>
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  <b>Salary Structure: </b>
                </Typography>
                <Typography variant="caption">
                  The monthly compensation of
                  <b> {`${data ? data.revisedSalary : 'Revised Salary'}`}/- </b>is structured as:
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  a) Monthly Fixed Pay: The employee will receive a monthly fixed pay of
                  <b> {`${data ? data.monthlySalary : 'Monthly Salary'}`}/-</b>. The same will be
                  reviewed on completion of your first Anniversary with the company and will undergo
                  a change basis your own ongoing individual performance.
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  b) Quarterly Variable Allowance: The variable pay will be
                  <b> {`${data ? data.quarterlyAllowance : 'Quarterly Allowance'}`}/- </b>per month,
                  and will be paid at the closure of each quarter based on the performance of the
                  individual. Quarterly Variable Allowance is subject to review on your first
                  anniversary and may undergo a change based on the actual performance of the
                  Company, your business unit and your own ongoing individual performance. The
                  payment is subject to your being active on the company rolls on the date of
                  announcement of Quarterly Variable Allowance.
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  We hope you will keep putting in your best efforts to excel further in your
                  career.
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  We wish you the best and believe you will continue excelling in your performance.
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2, fontStyle: 'italic' }}>
                  Please note that increment details are strictly private and confidential, and must
                  not be disclosed or discussed with others.
                </Typography>
                <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                  Regards
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Scrollbar>
    </>
  );
};

export default Compensation;
